<template>
  <footer class="py-6">
    <div class="main-content-ai no-top-padding">
      <div
        class="d-flex flex-column flex-md-row justify-space-between align-md-center"
      >
        <div class="d-flex mb-3 mb-md-0 flex-column flex-sm-row">
          <a
            class="font-weight-bold mb-4 mb-sm-0 mr-6 text-uppercase"
            href="https://amnistie.ca/sinformer"
            >S'informer</a
          >
          <a
            class="font-weight-bold mb-4 mb-sm-0 mr-6 text-uppercase"
            href="https://amnistie.ca/participer"
            >Participer</a
          >
          <a class="font-weight-bold mb-4 mb-sm-0 text-uppercase" href="#"
            >Donner</a
          >
        </div>
        <div class="d-flex flex-column flex-sm-row">
          <a
            href="https://www.facebook.com/AmnistieCA"
            class="font-weight-bold small mb-3 mb-sm-0 mr-sm-6 text-uppercase"
            >Facebook</a
          >
          <a
            href="https://twitter.com/AmnistieCA?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
            class="font-weight-bold small mb-3 mb-sm-0 mr-sm-6 text-uppercase"
            >Twitter</a
          >
          <a
            href="https://www.instagram.com/amnistie_canadafr/"
            class="font-weight-bold small mb-3 mb-sm-0 mr-sm-6 text-uppercase"
            >Instagram</a
          >
          <a
            href="https://www.youtube.com/user/AmnistieWeb/videos"
            class="font-weight-bold small mb-3 mb-sm-0 mr-sm-6 text-uppercase"
            >Youtube</a
          >
          <a
            href="https://www.linkedin.com/company/amnistie-internationale-canada-francophone?originalSubdomain=ca"
            class="font-weight-bold small mb-3 mb-sm-0 text-uppercase"
            >Linkedin</a
          >
        </div>
      </div>
    </div>

    <div class="sep my-6"></div>

    <div class="main-content-ai no-top-padding">
      <v-row>
        <v-col cols="12" sm="4">
          <div class="d-flex flex-column">
            <div class="text-uppercase mb-4 light">
              <a href="https://amnistie.ca/nous-soutenir">Nous soutenir</a>
            </div>
            <a href="https://amnistie.ca/campagnes" class="small mb-3 light"
              >Campagnes</a
            >
            <a href="https://amnistieca.square.site/" class="small mb-3 light">
              Boutique en ligne
              <img
                class="d-inline ml-1"
                src="@/assets/icons/externe-jaune.png"
                height="10"
                width="12"
              />
            </a>
            <a
              href="https://amnistie.ca/devenir-membre"
              class="small mb-3 light"
              >Devenir membre</a
            >
            <a
              href="https://amnistie.ca/groupes-militants"
              class="small mb-3 light"
              >Groupes et militants</a
            >
            <a
              href="https://amnistie.ca/espace-jeunesse"
              class="small mb-3 light"
              >Espace jeunesse</a
            >
            <a href="https://amnistie.ca/benevolat" class="small mb-3 light"
              >Bénévolat</a
            >
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="d-flex flex-column">
            <div class="text-uppercase mb-4 light">
              <a href="https://amnistie.ca/propos-damnistie-internationale"
                >À propos</a
              >
            </div>
            <a href="#" class="small mb-3 light">Offres d'emploi et stages</a>
            <a href="https://amnistie.ca/nous-joindre" class="small light"
              >Nous joindre</a
            >
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="d-flex flex-column">
            <a href="https://amnistie.ca/media" class="small mb-3 light"
              >Médias</a
            >
            <a
              href="https://amnistie.ca/sinformer?article_type_target_id=494&country_target_id=All&year=All"
              class="small mb-3 light"
              >Magazines</a
            >
            <a
              href="https://amnistie.ca/sinformer?article_type_target_id=531&country_target_id=All&year=All"
              class="small mb-3 light"
              >Bulletins des donateurs</a
            >
            <a href="https://amnistie.ca/evenements" class="small light"
              >Événements</a
            >
          </div>
        </v-col>
      </v-row>
    </div>

    <div class="sep my-6"></div>

    <div class="main-content-ai no-top-padding">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column flex-sm-row mb-3">
          <a
            href="https://amnistie.ca/propos-de-ce-site"
            class="small grey--text text--lighten-5 mr-sm-6 mb-3 mb-sm-0 light"
            >À propos de ce site</a
          >
          <a
            href="https://amnistie.ca/conditions-dutilisation"
            class="small grey--text text--lighten-5 mr-sm-6 mb-3 mb-sm-0 light"
            >Conditions d'utilisation</a
          >
          <a
            href="https://amnistie.ca/politique-de-confidentialite"
            class="small grey--text text--lighten-5 mr-sm-6 mb-3 mb-sm-0 light"
            >Politique de confidentialité</a
          >
        </div>
        <div class="caption grey--text d-flex flex-column flex-md-row">
          <span>&copy; 2020 Amnistie internationale Canada francophone</span>
          <span>
            <span class="d-none d-md-inline-block mx-2">-</span>Organisme de
            charité #100193457RR0001
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
footer {
  margin-top: 50px;
  background-color: black;
  color: #ff0;
  .sep {
    height: 1px;
    width: 100%;
    background-color: #6b6b6b;
  }
  a {
    color: #ff0;
    font-size: 20px;
    letter-spacing: 1.25px;
    text-decoration: none;
    &.small {
      font-size: 14px;
    }

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>